import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from "./Footer";
import Header from "./Header";
import 'flatpickr/dist/flatpickr.min.css';
import ErrorImg from './assets/img/ErrorImg.png';


const ErrorPage = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(true); // Default to open
    const location = useLocation()
    const {errorMessage} = location.state || {};
    return (
        <>
            <Header></Header>
            <div className="mainContent">
                <div className="unableProcessPayWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="imgWrap">
                                    <img src={ErrorImg} className="img-fluid" alt="" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="dataWrap">
                                    <div className="topWrap">
                                        <h2>We are sorry we were unable
                                            to process your booking.</h2>
                                        <p>{errorMessage}</p>
                                    </div>
                                    <div className="btmWrap">
                                        <div className="infoWrap">
                                            <h3>NOTE:</h3>
                                            <p> If your payment has been deducted but not received a a booking confirmation, please contact
                                                customer support <a href="mailto:jgtravelscustomersuport@gmail.com">“jgtravelscustomersuport@gmail.com”</a> with subject ‘web payment error’</p>
                                        </div>
                                        <button className="btn">RETRY</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer></Footer>
        </>
    );
}
export default ErrorPage;